
import React, { useState, useEffect, useRef } from "react";
// import "./Support.css";
import { FaPhoneAlt } from 'react-icons/fa';

const Support = ({ numbers = ['+919876543210'] }) => {
  const [expandedCategories, setExpandedCategories] = useState({});
  const [expandedQuestions, setExpandedQuestions] = useState({});
  const [showChatPopup, setShowChatPopup] = useState(false);
  const [chatMessage, setChatMessage] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [ticketType, setTicketType] = useState("");
  const [tickets, setTickets] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activeChat, setActiveChat] = useState(false);
  const [isTicketPopupVisible, setIsTicketPopupVisible] = useState(false);
  const [isChatPopupVisible, setIsChatPopupVisible] = useState(false);

  const [open, setOpen] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const containerRef = useRef(null);

  const simCall = (number) => {
    const clean = number.replace(/[^0-9+]/g, "");
    window.location.href = "tel:+919876543210";
  };

  const [messages, setMessages] = useState([
    { text: "Hello! Thank you for contacting support. How can I help you today?", type: "agent", time: "10:00 AM" },
  ]);
  const [inputMessage, setInputMessage] = useState("");

  const handleSend = () => {
    if (inputMessage.trim() === "") return;

    const newUserMsg = {
      text: inputMessage,
      type: "user",
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };

    setMessages((prev) => [...prev, newUserMsg]);

    setTimeout(() => {
      const replyText = getAgentReply(inputMessage);

      const agentMsg = {
        text: replyText,
        type: "agent",
        time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      };

      setMessages((prev) => [...prev, agentMsg]);
    }, 1000);

    setInputMessage("");
  };

  const getAgentReply = (message) => {
    const msg = message.toLowerCase();

    if (msg.includes("order")) return "Sure! Please share your order ID.";
    if (msg.includes("id")) return "Thank you! Give me a moment while I check the order details.";
    if (msg.includes("status")) return "Your order is currently being processed and will be delivered soon.";
    if (msg.includes("refund")) return "Refund requests take 3–5 business days to process, I can help you raise one.";
    
    return "Thank you for your message. Could you please provide more details?";
  };

  const fetchTickets = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) return console.log("❌ No token found");

      let userId = null;
      const user = localStorage.getItem("user");
      const userIdKey = localStorage.getItem("userId");

      if (user) {
        const parsedUser = JSON.parse(user);
        userId = parsedUser?.id || parsedUser?.userId;
      }

      if (!userId && userIdKey) {
        try {
          const parsedUserId = JSON.parse(userIdKey);
          userId = parsedUserId?.userId || parsedUserId;
        } catch {
          userId = userIdKey;
        }
      }

      if (!userId) return console.log("❌ No userId found");

      const response = await fetch(
        ` https://backend.maamaas.com/food/api/tickets/user/${userId}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        }
      );

      if (!response.ok) return console.log("❌ API failed. Status:", response.status);

      const data = await response.json();
      console.log("🎟 Tickets Data:", data);
      setTickets(data);
    } catch (err) {
      console.error("🔥 Error fetching tickets:", err);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
        setFocusedIndex(-1);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if (!open) return;
      if (e.key === "Escape") {
        setOpen(false);
        setFocusedIndex(-1);
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        setFocusedIndex((i) => Math.min(i + 1, numbers.length - 1));
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setFocusedIndex((i) => Math.max(i - 0, 0));
      } else if (e.key === "Enter") {
        if (focusedIndex >= 0 && focusedIndex < numbers.length) {
          simCall(numbers[focusedIndex]);
        }
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, focusedIndex, numbers]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (showChatPopup) {
      setTimeout(() => setIsTicketPopupVisible(true), 10);
    } else {
      setIsTicketPopupVisible(false);
    }
  }, [showChatPopup]);

  useEffect(() => {
    if (activeChat) {
      setTimeout(() => setIsChatPopupVisible(true), 10);
    } else {
      setIsChatPopupVisible(false);
    }
  }, [activeChat]);

  function toggleOpen(e) {
    e.stopPropagation();
    setOpen((o) => !o);
    if (!open) setFocusedIndex(0);
  }

  const faqCategories = [
    {
      id: "coupons",
      name: "Coupons & Offers",
      icon: "🎁",
      description: "Get help with discount codes and promotional offers",
      questions: [
        {
          question: "Coupon not working/expired coupon",
          answer: "Please check the coupon terms and validity before applying. If you're facing issues, ensure the coupon meets the minimum order value requirements and hasn't expired.",
        },
        {
          question: "I forgot to apply my coupon code. What do I do now?",
          answer: "Unfortunately, we can't apply coupons after order placement as our system processes orders immediately. Please ensure you apply coupons before completing your purchase.",
        },
        {
          question: "How do I refer my friend?",
          answer: "Go to the refer section in the app and follow the instructions. You'll find a unique referral code to share with friends. Both you and your friend will receive rewards when they make their first purchase.",
        },
      ]
    },
    {
      id: "orders",
      name: "Orders/Products Related",
      icon: "📦",
      description: "Questions about your orders and products",
      questions: [
        {
          question: "Can I reschedule my order?",
          answer: "If you've already placed an order, you can cancel it and place a new one when available. Please note that cancellation is only possible within 30 minutes of order placement.",
        },
        {
          question: "Can I edit my cart/add items?",
          answer: "We start packing your order right away to ensure fast delivery. So changes after placing the order aren't allowed. Please review your cart carefully before checkout.",
        },
        {
          question: "Is there a minimum order value?",
          answer: "No, we do not have a minimum or maximum order value. You can order any quantity you need without restrictions.",
        },
      ]
    },
    {
      id: "feedback",
      name: "Feedback & Suggestions",
      icon: "💬",
      description: "Share your feedback and suggestions with us",
      questions: [
        {
          question: "Out of stock?",
          answer: "We apologize for the inconvenience. Please check back later or try alternative products. We restock regularly and you can enable notifications for when your preferred items are available.",
        },
        {
          question: "Packing feedback?",
          answer: "We value your feedback on our packaging. Please share specific details so we can improve. Your input helps us maintain quality and sustainability standards.",
        },
        {
          question: "Any feedback/Review?",
          answer: "We'd love to hear from you! Please provide your feedback through our app or website. Your reviews help us serve you better and improve our services.",
        },
      ]
    }
  ];

  const toggleCategory = (categoryId) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  const toggleQuestion = (categoryId, questionIndex) => {
    const questionId = `${categoryId}-${questionIndex}`;
    setExpandedQuestions(prev => ({
      ...prev,
      [questionId]: !prev[questionId]
    }));
  };

  const handleSendMessage = async () => {
    if (!ticketType) {
      alert("Please select a ticket type");
      return;
    }

    if (!chatMessage.trim()) {
      alert("Please enter a message describing your issue");
      return;
    }

    if (selectedFile) {
      if (selectedFile.size > 5 * 1024 * 1024) {
        alert("File size should be less than 5MB");
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result;
        sendTicket(base64);
      };
      reader.onerror = () => {
        alert("Error reading file");
      };
      reader.readAsDataURL(selectedFile);
    } else {
      sendTicket(null);
    }
  };

  const sendTicket = async (base64) => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const userId = storedUser?.id;

    const payload = {
      userId: parseInt(userId),
      ticketType,
      status: "OPEN",
      message: chatMessage.trim(),
      attachmentUrl: base64 || null,
    };

    console.log("Sending payload:", payload);

    try {
      const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
      };

      const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }

      const csrfToken = getCSRFToken();
      if (csrfToken) {
        headers["X-CSRF-TOKEN"] = csrfToken;
      }

      const response = await fetch(
        " https://backend.maamaas.com/food/api/tickets/create",
        {
          method: "POST",
          headers: headers,
          credentials: 'include',
          body: JSON.stringify(payload),
        }
      );

      console.log("Response status:", response.status);

      const responseText = await response.text();
      console.log("Raw response:", responseText);

      if (!response.ok) {
        if (response.status === 403) {
          throw new Error("FORBIDDEN: No permission to create tickets");
        }
        if (response.status === 401) {
          throw new Error("UNAUTHORIZED: Please log in again");
        }
        throw new Error(`HTTP ${response.status}: ${responseText.substring(0, 100)}`);
      }

      let responseData;
      try {
        responseData = JSON.parse(responseText);
      } catch (e) {
        responseData = { message: "Ticket created successfully" };
      }

      alert("Ticket submitted successfully");
      setChatMessage("");
      setSelectedFile(null);
      setTicketType("");
      setShowChatPopup(false);
      fetchTickets();

    } catch (error) {
      console.error("Error submitting ticket:", error);

      if (error.message.includes('FORBIDDEN')) {
        alert("❌ Access Denied\n\nYou don't have permission to create support tickets. Please contact administrator.");
      } else if (error.message.includes('UNAUTHORIZED')) {
        alert("🔐 Session Expired\n\nPlease log in again to continue.");
      } else {
        alert(`Error: ${error.message}`);
      }
    }
  };

  const getCSRFToken = () => {
    const metaTag = document.querySelector('meta[name="_csrf"]');
    if (metaTag) return metaTag.getAttribute('content');

    const headerTag = document.querySelector('meta[name="_csrf_header"]');
    if (headerTag) return headerTag.getAttribute('content');

    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('XSRF-TOKEN='))
      ?.split('=')[1];

    return cookieValue || null;
  };

  const thStyle = {
    border: "1px solid #e1e5e9",
    padding: "12px",
    background: "linear-gradient(135deg, #9f52deff, #764ba2)",
    fontWeight: "600",
    color: "white"
  };

  const tdStyle = {
    border: "1px solid #e1e5e9",
    padding: "12px",
    color: "#4a5568"
  };

  const renderTicketTable = () => {
    return (
      <div className="ticket-section">
        <h4 className="section-title">Your Support Tickets</h4>
        <div className="table-container">
          <table className="ticket-table">
            <thead>
              <tr>
                <th style={thStyle}>Ticket ID</th>
                <th style={thStyle}>Ticket Type</th>
                <th style={thStyle}>Message</th>
                <th style={thStyle}>Created Date</th>
                <th style={thStyle}>Resolved Date</th>
                <th style={thStyle}>Status</th>
                <th style={thStyle}>Admin Response</th>
              </tr>
            </thead>
            <tbody>
              {tickets.length === 0 ? (
                <tr>
                  <td colSpan="7" style={{ ...tdStyle, textAlign: 'center' }}>
                    No tickets found
                  </td>
                </tr>
              ) : (
                tickets.map((ticket, index) => (
                  <tr
                    key={ticket.id}
                    className={index % 2 === 0 ? "even-row" : "odd-row"}
                  >
                    <td style={tdStyle}>{ticket.id}</td>
                    <td style={tdStyle}>{ticket.ticketType}</td>
                    <td style={tdStyle}>{ticket.message || "No message"}</td>
                    <td style={tdStyle}>
                      {new Date(ticket.createdAt).toLocaleString()}
                    </td>
                    <td style={tdStyle}>
                      {ticket.resolvedAt
                        ? new Date(ticket.resolvedAt).toLocaleString()
                        : "Pending"}
                    </td>
                    <td className={`status-${ticket.status.toLowerCase()}`}>
                      {ticket.status}
                    </td>
                    <td style={tdStyle}>{ticket.adminResponse || "Waiting for response"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="support-container">
      <div className="support-main">
        <div className="faqs-section">
          <div className="section-header">
            <h2 className="section-title">Frequently Asked Questions</h2>
            
          </div>

          <div className="faq-categories-container">
            {faqCategories.map((category) => {
              const isCategoryExpanded = expandedCategories[category.id];
              
              return (
                <div 
                  key={category.id} 
                  className={`faq-category ${isCategoryExpanded ? 'expanded' : ''}`}
                >
                  <div 
                    className="category-header"
                    onClick={() => toggleCategory(category.id)}
                  >
                    <div className="category-header-left">
                      <div className="category-icon">{category.icon}</div>
                      <div className="category-content">
                        <h3 className="category-title">{category.name}</h3>
                        <p className="category-description">{category.description}</p>
                      </div>
                    </div>
                    <div className="category-arrow">
                      {isCategoryExpanded ? "▲" : "▼"}
                    </div>
                  </div>
                  
                  {isCategoryExpanded && (
                    <div className="category-questions">
                      {category.questions.map((item, index) => {
                        const questionId = `${category.id}-${index}`;
                        const isQuestionExpanded = expandedQuestions[questionId];
                        
                        return (
                          <div 
                            key={questionId} 
                            className={`question-item ${isQuestionExpanded ? 'expanded' : ''}`}
                          >
                            <div
                              className="question-header"
                              onClick={() => toggleQuestion(category.id, index)}
                            >
                              <h5 className="question-text">{item.question}</h5>
                              <span className="question-expand-icon">
                                {isQuestionExpanded ? "−" : "+"}
                              </span>
                            </div>
                            {isQuestionExpanded && (
                              <div className="answer-content">
                                <p>{item.answer}</p>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="support-actions">
            <div className="action-buttons">
              <button
                className="action-btn primary-btn"
                onClick={() => setShowChatPopup(true)}
              >
                <span className="btn-icon">🎫</span>
                Raise A Ticket
              </button>

              <button
                className="action-btn tertiary-btn"
                onClick={() => setActiveChat(true)}
              >
                <span className="btn-icon">💬</span>
                Live Chat
              </button>
            </div>
          </div>

          {renderTicketTable()}
        </div>
      </div>

      {/* Raise Ticket Popup */}
      {showChatPopup && (
        <div className={`ticket-popup-overlay ${isTicketPopupVisible ? 'visible' : ''}`}>
          <div className="ticket-popup">
            <div className="popup-header">
              <h3>Raise a Support Ticket</h3>
              <button
                onClick={() => setShowChatPopup(false)}
                className="close-btn"
              >
                ×
              </button>
            </div>

            <div className="popup-body">
              <div className="form-group">
                <label>Ticket Type *</label>
                <select
                  value={ticketType}
                  onChange={(e) => setTicketType(e.target.value)}
                  className="form-select"
                  required
                >
                  <option value="">--Select Type--</option>
                  <option value="DELIVERY_ISSUE">Delivery Issue</option>
                  <option value="PAYMENT_PROBLEM">Payment Problem</option>
                  <option value="WRONG_ORDER">Wrong Order</option>
                  <option value="SERVICE_QUALITY">Service Quality</option>
                  <option value="OTHER">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label>Message *</label>
                <textarea
                  value={chatMessage}
                  onChange={(e) => setChatMessage(e.target.value)}
                  rows="4"
                  placeholder="Please describe your issue in detail..."
                  className="form-textarea"
                  required
                />
              </div>

              <div className="form-group">
                <label>Attachment (Optional)</label>
                <input
                  type="file"
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                  className="file-input"
                  accept="image/*,.pdf,.doc,.docx"
                />
                {selectedFile && (
                  <div className="file-info">
                    Selected: {selectedFile.name} ({(selectedFile.size / 1024).toFixed(2)} KB)
                  </div>
                )}
              </div>

              <button
                onClick={handleSendMessage}
                className="submit-btn"
                disabled={!ticketType || !chatMessage.trim()}
              >
                Submit Ticket
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Live Chat Popup */}
      {activeChat && (
        <div className={`chat-popup-overlay ${isChatPopupVisible ? 'visible' : ''}`}>
          <div className="chat-popup">
            <div className="chat-header">
              <div className="chat-title">
                <span className="status-indicator"></span>
                <h4>Live Chat Support</h4>
                <div className="call-dropdown-root" ref={containerRef}>
                  <button
                    aria-haspopup="listbox"
                    aria-expanded={open}
                    className={`call-icon-btn ${open ? 'open' : ''}`}
                    onClick={toggleOpen}
                    title="Call"
                  >
                    <FaPhoneAlt className="phone-icon" />
                    <span className="status-text">Support-Call</span>
                  </button>

                  <div className={`dropdown ${open ? 'visible' : ''}`} role="listbox" aria-label="Call numbers">
                    {numbers.map((num, idx) => (
                      <button
                        key={num}
                        className={`dropdown-item ${focusedIndex === idx ? "focused" : ""}`}
                        onClick={() => simCall(num)}
                        onMouseEnter={() => setFocusedIndex(idx)}
                      >
                        📞 {num}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
              <button
                onClick={() => setActiveChat(false)}
                className="close-btn"
              >
                ×
              </button>
            </div>

            <div className="chat-body">
              <div className="chat-messages">
                {messages.map((msg, index) => (
                  <div key={index} className={`message ${msg.type}-message`}>
                    <div className="message-content">
                      <p>{msg.text}</p>
                      <span className="message-time">{msg.time}</span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="chat-input">
                <input
                  type="text"
                  placeholder="Type your message..."
                  className="message-input"
                  value={inputMessage}
                  onChange={(e) => setInputMessage(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleSend()}
                />
                <button className="send-btn" onClick={handleSend}>➤</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Support;